module.exports = __webpack_public_path__ + "img/content.8dea9aaa.png";